/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Mød nye mennesker, chat, socialiser",
      "Forkert telefonnummer",
      "Get the app",
      "Fortsæt med Apple",
      "Fortsæt med Facebook",
      "Fortsæt med Google",
      "Log ind",
      "Tilmeld dig",
      "Indtast venligst de karakterer du ser i feltet for at fortsætte.",
      "Fortsæt",
      "Indtast karakterer",
      "Sikkerhedstjek",
      "Genindlæs",
      "Opret et nyt kodeord, som du nemt kan huske:",
      "Opdater",
      "Bekræft kodeord",
      "Kodeord skal være mindst {{num}} [[characters:num]]",
      "Kodeord",
      "Opret nyt kodeord",
      "Badoo - Blog",
      "Jobmuligheder",
      "Chat",
      "Byer",
      "Administrer Cookies",
      "Copyright © 2006 – til nu. Bumble. Alle rettigheder forbeholdes.",
      "Apple og Apple-logoet er varemærker tilhørende Apple Inc.{{__EOL__}}Google Play er et varemærke tilhørende Google LLC.",
      "Download",
      "Facebook",
      "Følg os",
      "Help Center",
      "Instagram",
      "Sprog",
      "LinkedIn",
      "Overblik",
      "Badoo er en del af Inc.",
      "Privatlivspolitik",
      "Safety Centre",
      "Sitemap",
      "Modern Slavery Act statement",
      "Vilkår og betingelser",
      "Twitter",
      "Indtast din e-mailadresse eller mobilnumme, og så sender vi dig instruktioner til at oprette et nyt kodeord.",
      "Få nyt kodeord",
      "Indtast din e-mail eller telefonnummer",
      "Glemt kodeord",
      "Modeller, der kun bruges til illustrative formål",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Der er ingen grund til at vente på et match.{{__EOL__}}{{__EOL__}}Dyk ned i de samtaler, der går lidt dybere, og gå direkte til de gode ting. Du ved, hvor man virkelig lærer hinanden at kende.",
      "Klar til at chatte?",
      "Ved at tilmelde dig, accepterer du vores <a class=\"link\" href=\"{{terms_url}}\">betingelser og vilkår</a>. Læs om, hvordan vi behandler dine data i vores <a class=\"link\" href=\"{{privacy_url}}\">privatlivspolitik</a>",
      "Vi hjælpe dig med at være dit ægte jeg, <br />til dating, der føles rigtig.",
      "Dating med selvtillid",
      "Eller",
      "Har du allerede en konto?",
      "Tilmeld dig med e-mail eller telefonnummer",
      "Få det, du vil have ud af dating.{{__EOL__}}Ingen grund til at undskylde.",
      "Vil du bare chatte? Det er OK.{{__EOL__}}Er du klar til at slå dig ned? Elsker det.{{__EOL__}}{{__EOL__}}Og hvis du nogensinde ombestemmer dig, kan du det når som helst.",
      "Her for at date",
      "Klar til et forhold",
      "Åben for chat",
      "Mød andre, der vil det samme.",
      "{{name}}, {{age}}",
      "Din sikkerhed er vores højeste prioritet.",
      "Vores Safety Centre er et videnscenter, der indeholder al den support, du har brug for til at date med tillid.",
      "Besøg vores Safety Centre",
      "Sikkerhed først<br/>– altid.",
      "Jeg tænkte helt fra starten, at det ville komme til at fungere ...",
      "Til at starte med, søgte jeg ikke noget seriøst…",
      "Et råd til alle på Badoo-appen er at være sig selv ...",
      "Badoo succeshistorier",
      "Tjek flere succeshistorier ud",
      "{{num}}__CUT__Bedømmelse",
      "Apple App Store",
      "Stol på os. Vi har bragt millioner (og millioner og millioner) af mennesker sammen siden 2006.",
      "{{num}}mio+__CUT__Downloads",
      "{{num}}mio+",
      "Google Play Store",
      "Vi ved, hvad vi laver.",
      "Log ind med din e-mail eller telefonnummer",
      "Indtast dit kodeord",
      "Glemt kodeord?",
      "Tilmeld dig",
      "Har du ikke en konto?",
      "Log ind",
      "Tilmeld dig"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "tegn",
                  "tegn"
            ],
            "singular": [
                  "tegn",
                  "tegn"
            ]
      },
      "day": {
            "plural": [
                  "dage",
                  "dages"
            ],
            "singular": [
                  "dag",
                  "dags"
            ]
      },
      "hour": {
            "plural": [
                  "timer",
                  "timers"
            ],
            "singular": [
                  "time",
                  "times"
            ]
      },
      "minute": {
            "plural": [
                  "minutter",
                  "minutters"
            ],
            "singular": [
                  "minut",
                  "minuts"
            ]
      },
      "month": {
            "plural": [
                  "måneder",
                  "måneders"
            ],
            "singular": [
                  "måned",
                  "måneds"
            ]
      },
      "second": {
            "plural": [
                  "sekunder",
                  "sekunders"
            ],
            "singular": [
                  "sekund",
                  "sekunds"
            ]
      },
      "year": {
            "plural": [
                  "år",
                  "årenes"
            ],
            "singular": [
                  "år",
                  "årets"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
